import angular from 'angular';

export default angular.module('components.navigation', [])
    .component('navigation', {
        template: require('./navigation.pug')(),
        controller: ['$state', '$window', 'AuthenticationService',  function($state, $window, AuthenticationService) { 
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.currentName = $state.current.name;
                ctrl.isAuthenticated = AuthenticationService.isAuthenticated();
                AuthenticationService.getProfile(function(err, profile) {
                    if (err) {
                        console.log(err.message || err);
                    } else {
                        ctrl.profile = angular.copy(profile);
                    }
                });
            };

            ctrl.menu = [
                {
                    ref: 'catalogue',
                    name: __("Catalogue")
                },
                {
                    ref: 'serials2',
                    name: __("Serials")
                },
                //{
                //    ref: 'serials',
                //    name: __("Serials")
                //},
                {
                    ref: 'ec',
                    name: __("eHoldings")
                },
                {
                    ref: 'kb',
                    name: __("Knowledge base")
                }
            ];

            ctrl.logout = function() {
                var self = this;
                AuthenticationService.logout(function(result) {
                    if (result === true) {
                        $state.go('login');
                    } else {
                        self.error = __("logout failed");
                    }
                });
            };
            ctrl.logout_portal = function() {
                $window.location.href='/api/v1/auth/portal/logout0';
            };
 
        }]
    })
    .component('navigationMenu', {
        bindings: {
            menu: '<'
        },
        template: require('./navigationMenu.pug')(),
        controller: ['$state', function($state) { 
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.currentName = $state.current.name;
            };

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    if (changes.menu) {
                        ctrl.menu = changes.menu.currentValue;
                    }
                }
            };

            ctrl.selectItem = function(item) {
                //console.log(item);
            };

        }]
    })
    .component('navigationItem', {
        bindings: {
            item: '<',
            onSelect: '&'
        },
        template: require('./navigationMenuItem.pug')(),
        controller: ['$state', function($state) {
            var ctrl = this;
            ctrl.$onInit = function() {
                ctrl.isActive = ctrl.item.ref === $state.current.name;
            };
            ctrl.$onChanges = function(changes) {
                if (changes.item) {
                    ctrl.item = changes.item.currentValue;
                }
            };

            ctrl.select = function() {
                ctrl.onSelect({item: ctrl.item});
            };
        }]
    })
    .name; 
